import { CButton, CFormCheck, CModal, CModalBody, CModalFooter, CModalHeader, CModalTitle } from '@coreui/react-pro'
import React from 'react'
import { isNotNull, logOutUser } from 'src/utils/constants'

const TncModal = ({
    user,
    acceptTnC,
    setAcceptTnC,
    handleVerify
}) => {

    const handlelogOut = () => {
        logOutUser();
        window.location.reload();
        return;
    }

    return (
        <div>
            <CModal
                fullscreen
                backdrop="static"
                alignment="center"
                size={'lg'}
                visible={true}
                onClose={() => handlelogOut()}
                aria-labelledby="StaticBackdropExampleLabel"
            >
                <CModalHeader closeButton={true}>
                    <CModalTitle id="StaticBackdropExampleLabel">Terms & Conditions</CModalTitle>
                </CModalHeader>
                <CModalBody>
                    <div className="relative w-full h-screen">
                        {
                            isNotNull(user?.tnc_document) &&
                            <iframe
                                src={`${user?.tnc_document}#toolbar=0&navpanes=0&scrollbar=0`}
                                title="PDF Viewer"
                                style={{
                                    width: "98vw",
                                    height: "100vh",
                                    border: "none",
                                    backgroundColor: "white"
                                }}

                            />
                        }
                    </div>
                </CModalBody>
                <CModalFooter>
                    <div className='d-flex w-100 justify-content-between align-items-center'>
                        <CFormCheck
                            label="Accept terms and conditions"
                            id="booker-email"
                            checked={acceptTnC}
                            onChange={() => setAcceptTnC(!acceptTnC)}
                        />
                        <CButton
                            color="primary"
                            onClick={() => handleVerify()}
                            disabled={!acceptTnC}
                        >
                            Verify
                        </CButton>
                    </div>
                </CModalFooter>
            </CModal>
        </div>
    )
}

export default TncModal